import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import serviceAvailability from '../../services/maintenance/serviceAvailability';
import { ROUTES } from '../../config/routes';

export default function MaintenanceGuard() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Initial check
    if (serviceAvailability.isMaintenanceMode && location.pathname !== ROUTES.MAINTENANCE) {
      navigate(ROUTES.MAINTENANCE, { replace: true });
    }

    // Subscribe to changes
    const unsubscribe = serviceAvailability.subscribe((isMaintenance) => {
      if (isMaintenance && location.pathname !== ROUTES.MAINTENANCE) {
        navigate(ROUTES.MAINTENANCE, { replace: true });
      } else if (!isMaintenance && location.pathname === ROUTES.MAINTENANCE) {
        navigate(ROUTES.DASHBOARD, { replace: true });
      }
    });

    return () => unsubscribe();
  }, [navigate, location.pathname]);

  useEffect(() => {
    // Global error listener for unhandled promise rejections (Firestore errors usually bubble up here)
    const handleUnhandledRejection = (event) => {
      if (serviceAvailability.isFatalError(event.reason)) {
        serviceAvailability.triggerMaintenance();
        event.preventDefault(); // Stop it from appearing in console if possible
      }
    };

    // Global error listener for synchronous/runtime errors
    const handleErrorEvent = (event) => {
      if (serviceAvailability.isFatalError(event.error)) {
        serviceAvailability.triggerMaintenance();
        event.preventDefault();
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleErrorEvent);
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleErrorEvent);
    };
  }, []);

  return null;
}
